// extracted by mini-css-extract-plugin
export default {"resourceList":"tS9g2pR4eEf5xwCSy9Aw","collection":"icSNO3AAZOjrdvz8jCea","compact":"hT_9NaZVkT7RzCjFf6nU","empty":"RvWb7EdUivXphXK3Cqht"};